module.exports = __webpack_public_path__ + "static/media/queplanta-text-light.d1f9b586.svg";